<template>
    <div class="advantage">
        <div class="container">
            <h4>{{ $t('home.advantage.title') }}</h4>
            <ul class="advantage-list">
                <li v-for="(advantage, index) in advantageList" :key="advantage.iconUrl"
                    :class="['advantage-item', index === 1 ? 'active' : '']">
                    <img :src="advantage.iconUrl" alt="" srcset="" />
                    <span>{{ advantage.desc }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'advantage-phone',

    data() {
        return {
        }
    },

    computed: {
        reasonList: () =>
            Array(4)
                .fill('')
                .map(() => ({
                    title: 'Global Operation',
                    content:
                        'Global Operations is a first-person tactical shooter video game developed ased in March 2002, following …',
                })),
        advantageList: function () {
            return [
                { iconUrl: require('../../assets/image/home/advantage_icon_activity.svg'), desc: this.$t('home.advantage.advantage1') },
                { iconUrl: require('../../assets/image/home/advantage_icon_security.svg'), desc: this.$t('home.advantage.advantage2') },
                { iconUrl: require('../../assets/image/home/advantage_icon_latency.svg'), desc: this.$t('home.advantage.advantage3') },
                { iconUrl: require('../../assets/image/home/advantage_icon_available.svg'), desc: this.$t('home.advantage.advantage4') },
                { iconUrl: require('../../assets/image/home/advantage_icon_order.svg'), desc: this.$t('home.advantage.advantage5') },
                { iconUrl: require('../../assets/image/home/advantage_icon_service.svg'), desc: this.$t('home.advantage.advantage6') }
            ]
        }
    },
}
</script>

<style scoped lang="scss">
.advantage {
    background: #F5F6F8;

    .container {
        width: 100vw;
        padding: 20px 15px;
        text-align: center;

        h4 {
            width: 100%;
            // height: 22.5px;
            font-size: 20px;
            font-family: Barlow-ExtraBold, Barlow;
            font-weight: 800;
            color: #000000;
            line-height: 22.5px;
        }

        .h4 {
            width: auto;
            height: 22.5px;
            margin: 0 auto;
        }
    }
}

.advantage-list {
    margin-top: 18px;

    .advantage-item {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 74px;
        background-color: #fff;
        border-radius: 5px;
        margin-bottom: 14px;
        padding: 18px 12.5px;
        box-shadow: 0px 2.5px 15px 0px rgba(73, 86, 117, 0.3000);

        img {
            width: 24px;
            height: 24px;
            float: left;
            margin-right: 20px;
        }

        span {
            display: block;
            width: calc(100% - 44px);
            line-height: 18.5px;
            color: #000;
            font-weight: bolder;
            text-align: left;
        }

        small {
            display: block;
            float: left;
            width: calc(100% - 104px);
            min-height: 18.5px;
            line-height: 18.5px;
            color: rgba(0, 0, 0, 0.6);
            font-weight: 400;
            text-align: left;
        }

        .btn {
            position: absolute;
            right: 10px;
            top: 20px;
            min-width: 75px;
            height: 30px;
            line-height: 30px;
        }
    }

    .active {
        background: #0d73d6;

        span,
        small {
            color: #fff;
        }
    }

}
</style>
